import React, { useEffect, useState } from "react"
import { Backdrop, Fade, Modal } from "@material-ui/core"
import { DateTime } from "luxon"
import EventDetails from "./EventDetails"

const EventsList = (props) => {
  const {
    cellSize,
    events,
    filters,
    path,
    rows,
    screenings,
    ticketing,
    track,
  } = props

  const [days, setDays] = useState([])

  const [modal, setModal] = useState({
    openedId: null,
    track: null,
  })

  useEffect(() => {
    const eventDays = []
    events.forEach((event) => {
      eventDays.push(event.date)
    })

    setDays(eventDays)
  }, [events])

  const handleOpen = (modalId, track) => {
    setModal({
      openedId: modalId,
      track,
    })
  }

  const handleClose = () => {
    setModal({
      openedId: null,
      track: null,
    })
  }

  const listEvents = (day, eventList) => {
    const dayString = `${day.get("monthShort")} ${day.get("day")}`

    const foundDay = eventList.find((d) => d.day === dayString)

    if (foundDay) {
      let foundEvents = []

      if (track === "unassigned") {
        foundEvents = foundDay.events.filter((e) => !e.tracks.length)
      } else {
        foundEvents = foundDay.events.filter((e) => e.tracks.includes(track))
      }

      if (foundEvents.length) {
        return (
          <>
            {foundEvents
              .sort((a, b) => a.start - b.start)
              .map((event, index) => (
                <React.Fragment key={`${event.id}-${index}`}>
                  {(filters.genre === "" ||
                    event.genres.includes(filters.genre)) &&
                    (filters.venue === "" || event.venue === filters.venue) && (
                      <>
                        <button
                          className='event-card'
                          onClick={() => handleOpen(event.id, null)}
                        >
                          <div className='event-card__inner'>
                            <h4>{event.title}</h4>
                            {event.start && (
                              <p>
                                {event.start.toLocaleString(
                                  DateTime.TIME_SIMPLE,
                                )}
                              </p>
                            )}
                          </div>
                        </button>

                        <Modal
                          open={modal.openedId === event.id}
                          onClose={handleClose}
                          BackdropComponent={Backdrop}
                          closeAfterTransition
                        >
                          <Fade in={modal.openedId === event.id}>
                            <div>
                              <EventDetails
                                event={event}
                                handleClose={handleClose}
                                festival={event.festival}
                                screenings={screenings}
                                ticketing={ticketing}
                                path={path}
                              />
                            </div>
                          </Fade>
                        </Modal>
                      </>
                    )}
                </React.Fragment>
              ))}
          </>
        )
      }
    }
  }

  return (
    <div
      className='events-lists'
      style={{
        width: cellSize * rows,
        gridTemplateColumns: `repeat(${rows}, 1fr)`,
      }}
    >
      {days.map((day, index) => (
        <div
          key={index}
          className='events-lists__day'
          style={{
            width: cellSize,
          }}
        >
          {listEvents(day, events)}
        </div>
      ))}
    </div>
  )
}

export default EventsList
